<template>
  <div>
    <b-carousel
      :interval="0"
      :controls="sortedImageSrcList.length !== 1"
      :indicators="sortedImageSrcList.length !== 1"
      class="w-100"
    >
      <b-carousel-slide
        v-for="(imageSrc, imageIndex) in sortedImageSrcList"
        :key="imageSrc"
      >
        <template #img>
          <b-img-lazy
            v-if="imageIndex !== 0"
            :src="imageSrc"
            :alt="productName"
          />
          <b-img
            v-else
            :src="imageSrc"
            :alt="productName"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>

<!--    <div v-else class="product-image-block d-flex flex-wrap justify-content-center align-items-center">-->
<!--      <Flipper :flip-key="sortKey">-->
<!--        <ul class="d-flex justify-content-start align-items-center flex-wrap">-->
<!--          <Flipped-->
<!--            v-for="(imageSrc, index) in sortedImageSrcList"-->
<!--            :key="imageSrc"-->
<!--            :flip-id="imageSrc"-->
<!--          >-->
<!--            <li-->
<!--              class="image-wrapper d-flex"-->
<!--              :class="{-->
<!--                'highlight': index === 0,-->
<!--                'cursor-pointer': index !== 0,-->
<!--              }"-->
<!--            >-->
<!--              <b-img-->
<!--                class="img-fluid"-->
<!--                :src="imageSrc"-->
<!--                :alt="productName"-->
<!--                @click="selectAndSortImage(index)"-->
<!--              />-->
<!--            </li>-->
<!--          </Flipped>-->
<!--        </ul>-->
<!--      </Flipper>-->
<!--    </div>-->

  </div>
</template>

<script>
import { Flipper, Flipped } from 'vue-flip-toolkit'
import { BCarousel, BCarouselSlide, BImg, BImgLazy } from 'bootstrap-vue'

export default {
  name: 'ProductImage',
  components: {
    Flipped,
    Flipper,
    'b-carousel': BCarousel,
    'b-carousel-slide': BCarouselSlide,
    'b-img-lazy': BImgLazy,
    'b-img': BImg,
  },
  props: {
    /**
     * termék képek listája
     */
    imageList: {
      type: Array,
      required: true,
    },
    /**
     * termék neve seo-hoz
     */
    productName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      /**
       * jelenleg aktiv kép indexe
       */
      selectedImageIndex: 0,
      /**
       * rendezett termék képek listája
       */
      sortedImageSrcList: [],
    }
  },
  computed: {
    /**
     * rendezés kulcs
     */
    sortKey() {
      return Object.values(this.sortedImageSrcList).join('')
    },
    /**
     * mobil nézet-e
     *
     * @return {boolean}
     */
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md'
    },
  },
  watch: {
    /**
     * termék kép listában lehet változás a termék oldalon paraméter váltásakor
     * ezt figyeljük, és ha történt ilyen, akkor a képek közül az egyetlen nem "lifeStyle" tipusu képét kicseréljük
     */
    imageList: function (newImageList) {
      const oldImageSrc = this.sortedImageSrcList.filter(oldImage => !newImageList.includes(oldImage))[0]
      const newImageSrc = newImageList.filter(newImage => !this.sortedImageSrcList.includes(newImage))[0]
      if (oldImageSrc !== undefined && newImageSrc !== undefined) {
        const oldImageSrcIndex = this.sortedImageSrcList.findIndex(oldImage => oldImage === oldImageSrc)
        if (oldImageSrcIndex !== -1) {
          this.$set(this.sortedImageSrcList, oldImageSrcIndex, newImageSrc)
        }
      }
    },
  },
  created() {
    this.sortedImageSrcList = this.imageList
  },
  methods: {
    /**
     * kép választva lett, átrendezzük a listát
     *
     * @param imageIndex
     */
    selectAndSortImage(imageIndex) {
      this.selectedImageIndex = imageIndex
      const tempOrderedImageList = []
      this.sortedImageSrcList.forEach((imageSrc, index) => {
        let order = index - this.selectedImageIndex
        if (order < 0) {
          order += this.sortedImageSrcList.length
        }
        tempOrderedImageList[order] = imageSrc
      })
      this.sortedImageSrcList = tempOrderedImageList
    },
  },
}
</script>

<style scoped lang="scss">
.product-image-block {
  max-width: 900px;

  ul {
    list-style: none;
  }

  .image-wrapper {
    //width: 344px;
    //height: 344px;
    width: 50%;
    margin: 10px 0;
    padding: 0 20px;

    &.highlight {
      max-width: 95%;
      width: 100%;
      height: 100%;
      max-height: 720px;
    }

    img {
      max-height: 720px;
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }
}

::v-deep .carousel-indicators {
  margin: 0;
  bottom: -10px;
  display: flex;
  justify-content: space-between;

  li {
    margin: 0;
    background-color: #111;
    width: 100%;
  }
}

.carousel.slide {
  @media screen and (max-width: 576px) {
    width: 86vw;
  }

  .carousel-item {
    object-fit: contain;
    width: 100%;
    height: 100%;
    text-align: center;

    img {
      object-fit: contain;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
